import React from "react";
import { Outlet } from "react-router-dom";

import Navbar from "components/navigation/Navbar";
import Sidebar from "components/navigation/Sidebar";
import AutoLogoutHandler from "components/common/AutoLogoutHandler";

export default function AdminLayout({ isSidebarOpen, toggleSidebar }) {
  return (
    <div className="min-h-screen bg-[var(--lightColor)] text-slate-800">
      <AutoLogoutHandler />
      <div className="flex min-h-screen">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

        <div className="flex min-w-0 flex-1 flex-col">
          <Navbar toggleSidebar={toggleSidebar} />
          <div className="crm-content min-w-0 flex-1 overflow-x-hidden">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
